module.exports = __webpack_public_path__ + "static/media/image-11.2a4861fb.webp";